// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tmap {
  width: 100%;
  height: min(52vh, 420px);
  border-radius: var(--radius);
  overflow: hidden;
  background: var(--bg);
}

.tmap-fallback {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 9px;
  height: 200px;
  border: 1px dashed var(--border-strong);
  border-radius: var(--radius);
  color: var(--muted);
  font-size: 0.88rem;
}
`, "",{"version":3,"sources":["webpack://./src/app/order/TrackingMap.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,wBAAwB;EACxB,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,uCAAuC;EACvC,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".tmap {\n  width: 100%;\n  height: min(52vh, 420px);\n  border-radius: var(--radius);\n  overflow: hidden;\n  background: var(--bg);\n}\n\n.tmap-fallback {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 9px;\n  height: 200px;\n  border: 1px dashed var(--border-strong);\n  border-radius: var(--radius);\n  color: var(--muted);\n  font-size: 0.88rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
